module.exports = __webpack_public_path__ + "static/img/empty_order.61f94d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/basic/empty_order.png
// module id = oQiZ
// module chunks = 113